<template>
  <label class="checkbox">
    <input
      type="checkbox"
      :checked="isChecked"
      @change="$emit('change', $event.target.checked)"
    />
    <span class="checkmark"></span>
    <span v-if="label" class="m-l-10">{{ label }}</span>
  </label>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: '',
    },
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isChecked() {
      return this.value;
    },
  },
}
</script>
